<template>
  <div>
    <el-radio-group v-model="dbType">
      <el-radio-button label="1" v-show="false">系统数据库</el-radio-button>
      <el-radio-button label="2">自定义数据库</el-radio-button>
    </el-radio-group>
    <div v-if="dbType==='1'" style="margin:10px 0">
      <el-select v-model="dbId" placeholder="请选择数据库">
        <el-option
          v-for="db in dbList"
          :key="db.id"
          :label="db.name"
          :value="db.id">
        </el-option>
      </el-select>
    </div>
    <div v-else  style="margin:10px 0">
      <div @click="isClose=!isClose" class="close-handler">
        <i v-if="isClose" class="fa fa-caret-right" aria-hidden="true"></i>
        <i v-if="!isClose" class="fa fa-caret-down" aria-hidden="true"></i>
      </div>
      <el-form :model="form"  v-show="!isClose">
        <el-form-item label="数据库类型">
          <el-select v-model="form.databaseType">
            <el-option label="oracle" value="oracle"></el-option>
            <el-option label="oracle集群" value="rac"></el-option>
            <el-option label="mysql" value="mysql"></el-option>
            <el-option label="sqlServer" value="sqlServer"></el-option>
            <el-option label="达梦" value="dameng"></el-option>
            <el-option label="神通" value="shenTong"></el-option>
            <el-option label="kingbase8" value="kingbase8"></el-option>
            <el-option label="kingbase7" value="kingbase7"></el-option>
            <el-option label="oceanbase" value="oceanbase"></el-option>
            <el-option label="postgresql" value="postgresql"></el-option>
            <el-option label="恒辉数据库" value="hhdb"></el-option>
            <el-option label="瀚高数据库" value="highgo"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="ip/端口">
          <el-col :span="12">
            <el-input v-model="form.ip"></el-input>
          </el-col>
          <el-col class="line" :span="1" style="text-align:center">:</el-col>
          <el-col :span="6">
            <el-input v-model="form.port"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="数据库实例">
          <el-input v-model="form.SID" style="width:200px"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="10">
            <el-form-item label="用户名">
              <el-input v-model="form.user" style="width:100px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="密码">
              <el-input type="password" v-model="form.password" style="width:100px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="text-align:center">
            <el-button @click="checkDBConnect">测试连接</el-button>
          </el-col>
        </el-row>
      </el-form>

    </div>
  </div>
</template>

<script>
  import dbTypeMap from './dbTypeMap'
  export default {
    props:{
      dbList:Array,
    },
    name: "databaseFormComp",
    data(){
      return {
        dbType:"2",
        form:{},
        dbId:"",
        isClose:false
      }
    },
    methods:{
      isSysDB(){
        return this.dbType === "1"
      },
      getDBTypeDef(){
        let form=this.form;
        let cfg= dbTypeMap[form.databaseType];
        if(!cfg){
          PF.message("未知数据库类型");
          return {};
        }
        let url=cfg.jdbcUrl;
        url=url.replace(/^tpl:/,"").replace(/\$\{(\w+)\}/g,(match,s1)=>{
          return form[s1];
        });
        return {url,cfg}
      },
      getDBConfig(){
        let params;
        if (this.isSysDB()) {
          if(!this.dbId)return null;
          if(this.dbId==='[PlatformDatabase]'){
            params={isPlatformDatabase:true}
          }else{
            params={id: this.dbId}
          }
          params.name=_.find(this.dbList,{id:this.dbId}).name;
        }else{
          let {cfg,url}= this.getDBTypeDef();
          if(!cfg || !url)return;
          params={
            jdbcUrl:url,
            driverClass:cfg.driverClass,
            password:this.form.password,
            user:this.form.user,
            name:this.form.SID+"_"+this.form.user
          }
        }
        return params;
      },
      checkDBConnect(){
        let form=this.form;
        if (this.isSysDB()) return PF.message("只测试自定义数据库");
        let {cfg,url}= this.getDBTypeDef();
        let params={
          url:url,
          driver:cfg.driverClass,
          p:form.password,
          u:form.user
        }
        _.assign(params,form);
        PF.fsrv("table.transfer.srv.checkDBConnect",params).then(({result})=>{
          if(result.success){
            PF.message("连接数据库成功");
          }else{
            PF.message("warning","连接数据库失败:"+result.errMsg)
          }
        });
      }
    }
  }
</script>

<style scoped>
  .close-handler{

    text-align: left;
    font-size: 18px;
    border-top: #1a97d7 solid 1px;
    width:300px;
    color:#1a97d7;
  }
</style>



// WEBPACK FOOTER //
// src/modules/index/views/maintain/databaseFormComp.vue